$(document).ready(function(){
    $('#return_search').on('change', function () {
        let uuid = $(this).val()
        let data = new FormData()
        data.append('uuid',uuid)
        sendData('/get-return-search',data)
    });

    function sendData(route,data) {
        $.ajax({
            url: route,
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                //No deshabilitamos ningun boton
            },
            success: function (response) {
                if (response.success) {
                    $('#div_return_search').html(response.view);
                }else {
                    alertError(response.message)
                }
            },
            error: function (xhr) {
                console.log(xhr);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error'
                });
            },
            complete: function () {
                //No deshabilitamos ningun boton
            }
        });
    }
})
